import { useAllEvents } from "./useAllEvents";

export const DEFAULT_PER_PAGE = 20;
export const CALENDAR_VIEW_PER_PAGE = 120;

export const useHasEvents = () => {
  const { events: pastEvents, isLoading: isLoadingPastEvents } = useAllEvents({
    params: { past_events: true },
  });

  const { events: upcomingEvents, isLoading: isLoadingUpcomingEvents } =
    useAllEvents({
      params: { past_events: false },
    });

  return {
    hasEvents: pastEvents.length > 0 || upcomingEvents.length > 0,
    isLoading: isLoadingPastEvents || isLoadingUpcomingEvents,
  };
};
